jQuery(function ($) {
    var moLocationsSliders = document.querySelectorAll('.mo-locations-slider');
    moLocationsSliders.forEach((moLocationsSlider) => {
        if (!moLocationsSlider) {
            return;
        }
        $(moLocationsSlider).slick({
            customPaging: function (slider, i) {
                var title = $(slider.$slides[i]).find('.slide').data('title');
                return '<a class="pager__item"> ' + title + ' </a>';
            },
        });
        let dotsOffsets = Array.from(moLocationsSlider.querySelectorAll('.slick-dots li')).map((dot) => dot.offsetLeft);
        //console.log('dotsOffsets', dotsOffsets);
        let dotsWidth = Array.from(moLocationsSlider.querySelectorAll('.slick-dots li')).map((dot) => dot.offsetWidth);
        //console.log('dotsWidth', dotsWidth);
        let parentOffsetCenter = moLocationsSlider.querySelector('.slick-dots').offsetWidth / 2;
        //console.log('parentOffsetCenter', parentOffsetCenter);

        // On slide change move scroll active dot to center
        $(moLocationsSlider).on('afterChange', function (event, slick, currentSlide) {
            var $dots = $(this).find('.slick-dots');
            var $activeDot = $dots.find('.slick-active');
            var $activeDotIndex = $activeDot.index();
            const scrollPosition = dotsOffsets[$activeDotIndex] - parentOffsetCenter + dotsWidth[$activeDotIndex] / 2;
            $dots.animate(
                {
                    scrollLeft: scrollPosition,
                },
                300
            );
        });

        $(moLocationsSlider).on('setPosition', function (event, slick) {
            
            // Parent width
            const parentWidth = moLocationsSlider.querySelector('.slick-dots').offsetWidth;

            // Recalculate
            dotsOffsets = Array.from(moLocationsSlider.querySelectorAll('.slick-dots li')).map((dot) => dot.offsetLeft);
            dotsWidth = Array.from(moLocationsSlider.querySelectorAll('.slick-dots li')).map((dot) => dot.offsetWidth);
            parentOffsetCenter = moLocationsSlider.querySelector('.slick-dots').offsetWidth / 2;

            const dotsWidthSum = dotsWidth.reduce((acc, width) => acc + width, 0);

            //console.log('parentWidth', parentWidth);
            //console.log('dotsWidthSum', dotsWidthSum);

            const dots = moLocationsSlider.querySelector('.slick-dots');
            // Change justify content to center if sum all li width is less than parent width
            if (parentWidth > dotsWidthSum + 80) {
                dots.style.justifyContent = 'center';
            } else {
                dots.style.justifyContent = 'flex-start';
            }
        });

        // Horizontall Scroll ----------------------------------------------
        let mouseDown = false;
        let startX, scrollLeft;
        const parentDots = moLocationsSlider.querySelector('.slick-dots');

        const startDragging = (e) => {
            mouseDown = true;
            startX = e.pageX - parentDots.offsetLeft;
            scrollLeft = parentDots.scrollLeft;
        };

        const stopDragging = (e) => {
            mouseDown = false;
        };

        const move = (e) => {
            e.preventDefault();
            if (!mouseDown) {
                return;
            }
            const x = e.pageX - parentDots.offsetLeft;
            const scroll = x - startX;
            parentDots.scrollLeft = scrollLeft - scroll;
        };

        parentDots.addEventListener('mousemove', move, false);
        parentDots.addEventListener('mousedown', startDragging, false);
        parentDots.addEventListener('mouseup', stopDragging, false);
        parentDots.addEventListener('mouseleave', stopDragging, false);
        // End Scroll --------------------------------------------------------
    });
});
